module.exports = __webpack_public_path__ + "static/img/process-27.d23d897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-27.jpg
// module id = /Tm2
// module chunks = 0